import * as React from "react";
import { cn } from "@/utils/css";

const Table = React.forwardRef(({ className, ...props }, ref) => {
    const isTableFixed = className?.includes("table-fixed");
    return (
        <div className="relative w-full overflow-auto">
            <table
                ref={ref}
                className={cn("border-spacing-0", isTableFixed ? "caption-bottom text-sm" : "w-full caption-bottom text-sm", className)}
                {...props}
            />
        </div>
    );
});
Table.displayName = "Table";

const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
    <thead ref={ref} className={cn("border-b", className)} {...props} />
));
TableHeader.displayName = "TableHeader";

const TableBody = React.forwardRef(({ className, ...props }, ref) => <tbody ref={ref} className={cn("border-0", className)} {...props} />);
TableBody.displayName = "TableBody";

const TableRow = React.forwardRef(({ className, ...props }, ref) => (
    <tr ref={ref} className={cn("border-t border-cm-p-outline transition-colors ", className)} {...props} />
));
TableRow.displayName = "TableRow";

const TableHead = React.forwardRef(({ className, children, ...props }, ref) => (
    <th ref={ref} className={cn("h-[44px] text-sm/[22px] text-cm-p-text-primary font-medium text-left ", className)} {...props}>
        <div className="px-2 py-3">{children}</div>
    </th>
));
TableHead.displayName = "TableHead";

export { Table, TableHeader, TableBody, TableHead, TableRow };
